// Chart.js 4 requires the chart elements + scales + plugins it'll use
// to be explicitly registered. Doing it once here keeps each chart
// wrapper a thin component and avoids `Bar`/`Line` from
// react-chartjs-2 throwing the cryptic "category is not a registered
// scale" at first paint.
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';

let registered = false;
export function ensureChartJsRegistered() {
  if (registered) return;
  ChartJS.register(
    ArcElement,
    BarElement,
    CategoryScale,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
  );
  registered = true;
}
